module.exports = __webpack_public_path__ + "static/foco_sementes_cia_logo-2ebedab45156517ede9d87da1c5c49e8.png";